import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toArray from "@babel/runtime/helpers/toArray";
import _typeof from "@babel/runtime/helpers/typeof";
// Copyright 1999-2020. Plesk International GmbH. All rights reserved.
import React, { PureComponent, isValidElement, cloneElement, createContext, useContext } from 'react';
import PropTypes from 'prop-types';

var applyParams = function applyParams(message) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var result = [];
  var hasElements = false;
  var m;

  while (m = message.match(/%%(\w+)%%/)) {
    var _m = m,
        _m$index = _m.index,
        index = _m$index === void 0 ? 0 : _m$index;

    if (index > 0) {
      result.push(message.substr(0, index));
    }

    var param = params[m[1]];

    if (param === undefined) {
      result.push(m[0]);
    } else if (_typeof(param) === 'object' && isValidElement(param)) {
      result.push(cloneElement(param, {
        key: m[1]
      }));
      hasElements = true;
    } else {
      result.push(param);
    }

    message = message.substr(index + m[0].length);
  }

  if (message !== '') {
    result.push(message);
  }

  return hasElements ? result : result.join('');
};

var getMessage = function getMessage(fullKey, messages) {
  var _fullKey$split = fullKey.split('.'),
      _fullKey$split2 = _toArray(_fullKey$split),
      key = _fullKey$split2[0],
      rest = _fullKey$split2.slice(1);

  var message = messages[key];

  if (_typeof(message) === 'object' && rest.length) {
    return getMessage(rest.join('.'), message);
  }

  return messages[fullKey];
}; // eslint-disable-next-line default-param-last


var createTranslate = function createTranslate(messages) {
  return function (key) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var fallback = arguments.length > 2 ? arguments[2] : undefined;

    if (typeof key !== 'string') {
      return '';
    }

    var message = getMessage(key, messages);

    if (typeof message !== 'string') {
      message = typeof fallback === 'string' ? fallback : "[".concat(key, "]");
    }

    return applyParams(message, params);
  };
};

var LocaleContext = createContext(undefined);
export var useTranslate = function useTranslate(namespace) {
  var context = useContext(LocaleContext);
  return function (key, params, fallback) {
    if (context) {
      var lmsg = context.locale.lmsg;
      return lmsg(namespace ? "".concat(namespace, ".").concat(key) : key, params, fallback);
    }

    return typeof fallback === 'string' ? applyParams(fallback, params) : "[".concat(key, "]");
  };
};

/**
 * LocaleProvider provides a uniform localization support for built-in text of components.
 * @since 0.0.42
 */
var LocaleProvider =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(LocaleProvider, _PureComponent);

  function LocaleProvider() {
    _classCallCheck(this, LocaleProvider);

    return _possibleConstructorReturn(this, _getPrototypeOf(LocaleProvider).apply(this, arguments));
  }

  _createClass(LocaleProvider, [{
    key: "getChildContext",
    value: function getChildContext() {
      var messages = this.props.messages;
      return {
        locale: {
          lmsg: createTranslate(messages)
        }
      };
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return React.createElement(LocaleContext.Provider, {
        value: this.getChildContext()
      }, children);
    }
  }]);

  return LocaleProvider;
}(PureComponent);

_defineProperty(LocaleProvider, "childContextTypes", {
  locale: PropTypes.object
});

export default LocaleProvider;